import { toHttpParams } from '@/utils/common'
import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { ISolicitacaoChatMessage } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-message.interface'
import { SolicitacaoChatAreaResponsavelEnum } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-area-responsavel.enum'
import { ISolicitacaoChatFilter } from '../../../types/interfaces/solicitacao-chat/solicitacao-chat-filter.interface'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async listAllBackofficeChat(data: ISolicitacaoChatFilter) {
    const queryParams = toHttpParams(data)
    const request = await api.get(`/solicitacoes-backoffice-chat?${queryParams}`)
    return factory.build(request)
  },

  async getChatBySolicitationId(id: string) {
    const request = await api.get(`/solicitacoes/${id}/chat`)
    return factory.build(request)
  },

  async admit(solicitacaoId: string) {
    const request = await api.put(`/solicitacoes/${solicitacaoId}/chat/assumir-atendimento`, {})
    return factory.build(request)
  },

  async changeArea(solicitacaoId: string, area: SolicitacaoChatAreaResponsavelEnum) {
    const request = await api.put(`/solicitacoes/${solicitacaoId}/chat/encaminhar-para-area-responsavel/${area}`, {})
    return factory.build(request)
  },

  async createMessage(solicitacaoId: string, data: ISolicitacaoChatMessage) {
    const response = await api.post(`/solicitacoes/${solicitacaoId}/chat/mensagem`, data)
    return factory.build(response)
  },

  async markChatAsRead(solicitacaoId: string) {
    const response = await api.put(`/solicitacoes/${solicitacaoId}/chat/visualizado`, {})
    return factory.build(response)
  },
}
